import React from 'react';
import { Box, Text, Flex, Tooltip, Icon, useDisclosure } from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';
import UpgradeModal from './UpgradeModal';
import useAuth from '../../hooks/use-Auth';

const VIPFeatureIndicator = ({ 
  feature, 
  children, 
  showLock = true,
  isDisabled = false
}) => {
  const { isFreeTier } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // If user is on VIP tier, just render children normally
  if (!isFreeTier) {
    return <>{children}</>;
  }

  // For free tier users, wrap content with VIP indicator
  return (
    <>
      <Tooltip 
        hasArrow 
        label="VIP feature - upgrade required" 
        placement="top"
        isDisabled={!showLock}
      >
        <Box 
          position="relative" 
          onClick={isDisabled ? onOpen : undefined}
          cursor={isDisabled ? "pointer" : "default"}
          opacity={isDisabled ? 0.7 : 1}
          filter={isDisabled ? "grayscale(30%)" : "none"}
        >
          {children}
          
          {showLock && (
            <Flex
              position="absolute"
              top={2}
              right={2}
              bg="purple.500"
              color="white"
              borderRadius="md"
              px={2}
              py={1}
              alignItems="center"
              fontSize="xs"
              cursor="pointer"
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
              }}
              _hover={{
                bg: "purple.600"
              }}
            >
              <Icon as={LockIcon} mr={1} />
              <Text fontWeight="bold">VIP</Text>
            </Flex>
          )}
        </Box>
      </Tooltip>

      <UpgradeModal isOpen={isOpen} onClose={onClose} feature={feature} />
    </>
  );
};

export default VIPFeatureIndicator; 